import { getCompaniesCompanyIdDevelopersDeveloperIdCacheKey } from "../companiesCompanyIdDevelopersDeveloperId/constants";
import type { AllRouteEndpoints } from "../routeTypes";

// Resending rotates the invitation token and clears the "expired" state, so refetch the developer afterwards.
export const companiesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationCacheKeys: AllRouteEndpoints[] = [
  getCompaniesCompanyIdDevelopersDeveloperIdCacheKey,
];
